import { Component, computed, inject } from '@angular/core';

import { AsideService } from '../../../../core/services/aside.service';
import { AddStopFormComponent } from '../../add-stop-form/add-stop-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoadDetailsComponent } from '../../../../pages/loads/load-details/load-details.component';
import { FleetAsideComponent } from '../../../../pages/fleet/fleet-aside/fleet-aside.component';
import { TeamAsideComponent } from '../../../../pages/team/team-aside/team-aside.component';
import { DriverAsideComponent } from '../../../../pages/drivers/driver-aside/driver-aside.component';
import { InvoiceAsideComponent } from '../../../../pages/invoicing/invoice-aside/invoice-aside.component';
import { ReadyLoadAsideComponent } from '../../../../pages/invoicing/ready-load-aside/ready-load-aside.component';

@Component({
  selector: 'app-aside-content',
  standalone: true,
  imports: [
    AddStopFormComponent,
    ReactiveFormsModule,
    LoadDetailsComponent,
    FleetAsideComponent,
    TeamAsideComponent,
    DriverAsideComponent,
    InvoiceAsideComponent,
    ReadyLoadAsideComponent,
],
  template: `
    @if (context(); as ctx) {
      @for (swapKey of [entityKey()]; track swapKey) {
        <div animate.enter="hv-aside-swap" class="h-full">
          @switch (ctx.type) {
            @case ('edit-stop') {
              <app-add-stop-form
                [formControl]="ctx.data.formControl"
                [stopNumber]="ctx.data.stopNumber"
              ></app-add-stop-form>
            }
            @case ('view-ready-load') {
              <app-ready-load-aside></app-ready-load-aside>
            }
            @case ('view-details') {
              <app-load-details
                [id]="ctx.data.id"
                [load]="ctx.data.details"
                [viewContext]="'list-page'"
              ></app-load-details>
            }
            @case ('view-pdf') {
              <iframe
                [src]="getSafeUrl(ctx.data.pdfUrl)"
                class="w-full h-full border-0"
              ></iframe>
            }
            @case ('view-asset') {
              <app-fleet-aside></app-fleet-aside>
            }
            @case ('view-team-member') {
              <app-team-aside></app-team-aside>
            }
            @case ('view-driver') {
              <app-driver-aside></app-driver-aside>
            }
            @case ('view-invoice') {
              <app-invoice-aside></app-invoice-aside>
            }
          }
        </div>
      }
    }
  `,
})
export class AsideContentComponent {
  protected readonly asideService = inject(AsideService);
  private readonly sanitizer = inject(DomSanitizer);
  protected context = this.asideService.asideContext;

  protected readonly entityKey = computed(() => {
    const ctx = this.context();
    if (!ctx) return 'none';
    switch (ctx.type) {
      case 'edit-stop':
        return `edit-stop:${ctx.data.stopNumber}`;
      case 'view-pdf':
        return `view-pdf:${ctx.data.pdfUrl}`;
      case 'view-details':
      case 'view-asset':
      case 'view-team-member':
      case 'view-driver':
      case 'view-invoice':
      case 'view-ready-load':
        return `${ctx.type}:${ctx.data.id}`;
    }
  });

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
